import { DialogProps, Drawer } from 'vaul'
import { Colors } from 'cio-design-library/design-tokens'
import { Icon24 } from 'builder/components/Icon'
import {
  Content,
  DrawerClose,
  DrawerHeader,
  DrawerParagraph,
  DrawerTitle,
  Footer,
  Overlay,
} from './styles'

type DrawerModalProps = DialogProps & {
  title?: string
  description?: string
  footer?: React.ReactNode
  children?: React.ReactNode
  trigger?: React.ReactNode
}

export default function DrawerModal({
  title,
  description,
  footer,
  children,
  trigger,
  ...props
}: DrawerModalProps) {
  return (
    <Drawer.Root {...props}>
      {trigger && <Drawer.Trigger asChild>{trigger}</Drawer.Trigger>}
      <Drawer.Portal>
        <Overlay />
        <Content>
          {(title || description) && (
            <>
              <DrawerClose>
                <Icon24.CloseIcon color={Colors.Neutral5} />
              </DrawerClose>
              <DrawerHeader>
                {title && <DrawerTitle>{title}</DrawerTitle>}
                {description && <DrawerParagraph>{description}</DrawerParagraph>}
              </DrawerHeader>
            </>
          )}
          {children}
          {footer && <Footer>{footer}</Footer>}
        </Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
}

export * as VaulDrawer from 'vaul'
